import React, {useState} from 'react'
import { useSelector } from 'react-redux'
import ManageDepartment from '../../../components/Multi/Multi-Department/ManageDepartment'
import CustomBreadcrumbs from '../../../components/Tools/Breadcumbs'
import CreateButton from '../../../components/Tools/CreateButton'
import MainFilter from '../../../components/Tools/MainFilter'
import DashboardFilter from '../../Dashboard/components/DashboardFilter'
const Departments = () => {
  const {authData}=useSelector((state)=>state.authData);
  const [open, setOpen] = useState(false);
  const [filterPayload, setFilterPayload] = useState({
      searchStr: "",
      fromDate: "",
      toDate: "",
      dateColumn: "",
      department_id: "",
      tier: ""
  });

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleFilterClick = async () => {
    setOpen(false);
  };
  const handleInput = async (e) => {
      const {name, value} = e.target;
      setFilterPayload((prev) => ({
          ...prev, [name]: value
      }));
  }

  const handleFilterRemove = async (name) => {
     const newPayload = {
      ...filterPayload,
      [name]: "",
    };
    setFilterPayload(newPayload);
  }


  return (
    <div>
      <div className='scheme p-2'>
        <div className="row" style={{ padding: "10px 16px" }}>
            <div className="col-md-6">
                <h4 style={{ color: "#28326f", margin: 0 }}>Department</h4>
                <CustomBreadcrumbs linksArray={[]} title="Department" />
            </div>
        </div>
        <DashboardFilter 
          openFilterModal={setOpen} 
          filterPayload={filterPayload} 
          handleFilterRemove={handleFilterRemove}
          isTierRemovalRequired={true}
        />
        <ManageDepartment searchStr={filterPayload.searchStr} tier={filterPayload.tier}></ManageDepartment>
      </div>
      { authData.user.user_type === 'l3' && <CreateButton title={"Add Department"} url={"/add-department"}/> }
      
      <MainFilter 
        open={open} 
        handleClose={handleClose} 
        handleInput={handleInput} 
        handleOpen={handleOpen}
        filterPayload={filterPayload}
        handleFilterClick={handleFilterClick}
        isDepartmentRequired={false}
      />
    </div>
  )
}

export default Departments